import { BaseWebComponentController, IListenerConfig } from '../../../../../framework/BaseWebComponentController';
import { GridEvents } from '../../../../../grid/types/common';
import { AtlassianJiraConfluenceGridWebComponent } from '../component/AtlassianJiraConfluenceGridWebComponent';
import { templateAtlassianJiraConfluenceGrid } from '../view/template';
import { AtlassianJiraConfluenceGridRepository } from '../repository/AtlassianJiraConfluenceGridRepository';
import { AtlassianJiraConfluenceGridView } from '../view/AtlassianJiraConfluenceGridView';
import { AtlassianJiraConfluenceGridViewData } from '../types';
import { AtlassianJiraConfluenceSensorDetails } from '../../atlassianJiraConfluence/types';

export class AtlassianJiraConfluenceGridController extends BaseWebComponentController {
  public component: AtlassianJiraConfluenceGridWebComponent;
  public dataRepository: AtlassianJiraConfluenceGridRepository;
  public view: AtlassianJiraConfluenceGridView;
  public viewConstructor: typeof AtlassianJiraConfluenceGridView;
  public dataRepositoryConstructor: typeof AtlassianJiraConfluenceGridRepository;

  constructor(component: AtlassianJiraConfluenceGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: AtlassianJiraConfluenceGridView,
      viewTemplate: templateAtlassianJiraConfluenceGrid,
      dataRepositoryConstructor: AtlassianJiraConfluenceGridRepository,
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$gridView,
        event: GridEvents.GRID_LOADED,
        callback: this.gridLoaded,
      }
    ];
  }

  public async getDataForView(): Promise<AtlassianJiraConfluenceGridViewData> {
    return await this.dataRepository.getDataForView();
  }

  public async addToList(sensorList: AtlassianJiraConfluenceSensorDetails[]): Promise<void> {
    for (const sensor of sensorList) {
      await this.view.dom.$gridView.dataProvider.addToList(sensor);
    }
    await this.view.dom.$gridView.controller.handleGridItemsLoad();
  }

  public async setData(viewData: any): Promise<void> {
    this.view.dom.$gridView.dataProvider.setData(viewData.response);
    await this.view.dom.$gridView.controller.handleGridItemsLoad();
  }

  private gridLoaded(): void {
    this.component.dispatchEvent(
      new CustomEvent(GridEvents.GRID_LOADED, {
        detail: {},
        bubbles: true,
      })
    );
  }
}
